import { render } from "./config-error.component.vue?vue&type=template&id=017e0dc6&ts=true"
import script from "./config-error.component.ts?vue&type=script&lang=ts"
export * from "./config-error.component.ts?vue&type=script&lang=ts"

import exportComponent from "/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__